import type { PropsWithChildren } from "react";

import { useGetAllInvoiceComments } from "@/queries/invoice-comments/get-all";
import { CommentsPopover } from "./comments-popover";

type Props = PropsWithChildren<{
  invoiceId: string;
}>;

export const WithComments = ({ invoiceId, children }: Props) => {
  const { invoiceComments } = useGetAllInvoiceComments({
    invoiceId,
  });

  if (invoiceComments?.length === 0) {
    return null;
  }

  return <CommentsPopover invoiceId={invoiceId}>{children}</CommentsPopover>;
};
